import React, { useState, useCallback } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { SelectInput } from "../../../components/inputs/final_form/SelectInput";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { api, extractErrorMessage } from "../../../util/api";
import { GROUP_TYPES } from "../../../util/data/group_types";
import { objectToOptions } from "../../../util/formatters";
import { required } from "../../../util/validators";
import { snakifyKeys } from "../../../util/helpers";
import { AdministrateSelectInput } from "../../components/inputs/AdministrateSelectInput";
import { Switch } from "../../../components/inputs/final_form/Switch";

const globalGroupTypes = objectToOptions(GROUP_TYPES);

export const AddGroupModal = ({ onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (values) => {
      setError(null);
      try {
        await api.post("/admin/groups", { group: snakifyKeys(values) });

        onAdd?.(values);

        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd]
  );

  return (
    <>
      <Button color="primary" onClick={toggleModal} {...rest}>
        Add New User Group
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add Group</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate}>
            {({ handleSubmit, submitting }) => {
              return (
                <>
                  <Field component={TextInput} label="Group Name" name="teamName" required validate={required} />
                  <Field
                    component={SelectInput}
                    options={globalGroupTypes}
                    label="Group Type"
                    name="groupType"
                    required
                    validate={required}
                  />
                  <Field
                    component={AdministrateSelectInput}
                    resourceUrl="/admin/accounts.json?for_groups=true"
                    required
                    validate={required}
                    label="Group Lead"
                    name="leaderAccountId"
                    labelKey="full_name_or_email"
                  />
                  <Field
                    component={AdministrateSelectInput}
                    resourceUrl="/admin/accounts.json?for_groups=true"
                    required
                    label="Members"
                    name="accountIds"
                    labelKey="full_name_or_email"
                    isMulti
                  />

                  <Field
                    className="mb-3"
                    component={Switch}
                    type="checkbox"
                    label="Fall Through Received Cases"
                    name="fallThroughReceivedCases"
                  />

                  <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                    Submit
                  </LoadingButton>
                </>
              );
            }}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
